import { AlertClassKey } from '@material-ui/lab/Alert';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const THDAlertStyles: Partial<Record<AlertClassKey, CSSProperties>> = {
  root: {
    position: 'relative',
    alignItems: 'flex-start',
    borderRadius: 2,
    fontSize: 16,
    fontWeight: 400,
    padding: '15px 20px',
    fontFamily: 'helvetica-neue,Helvetica Neue,Helvetica,Arial,sans-serif',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      width: 3,
    },
  },
  outlinedError: {
    color: '#212120',
    border: '1px solid #7A7978',
    '&::before': {
      backgroundColor: '#E34A4A',
    },
  },
  outlinedInfo: {
    color: '#212120',
    border: '1px solid #7A7978',
    '&::before': {
      backgroundColor: '#62D4CA',
    },
  },
  outlinedWarning: {
    color: '#212120',
    border: '1px solid #7A7978',
    '&::before': {
      backgroundColor: '#FBC524',
    },
  },
  outlinedSuccess: {
    color: '#212120',
    border: '1px solid #7A7978',
    '&::before': {
      backgroundColor: '#1DDB7F',
    },
  },
  icon: {
    opacity: 1,
    padding: '0',
    marginRight: 16,
  },
  message: {
    padding: '2px 0',
  },
  action: {
    marginRight: 0,
    '& > .MuiButtonBase-root': {
      padding: '5px 0',
    },
  },
};
